module.exports = __webpack_public_path__ + "static/2-1789ff8e10a63a96123cea2963ad4c7f.jpg";